import pubsub from '@viewlift/pubsub'
import React, { useEffect,useState,useRef } from 'react'
import { registerTveUser } from './registerTveUser'
import TveDialogBox from './TveDialogBox'
import './index.scss'
import loadTve,{loadScript} from '../../../../helpers/loadTve'
import Cookies from 'js-cookie'
import Spinner from '../../../../components/spinner'
import { fetchUserObject } from '../../../../MFEs/Monetization-Sdk/src/fetchStore'
import { getTokenForDevice, registerDevice } from '../../../../components/ActivateTveDevice/registerDevice'
import axios from 'axios'
import { publishUserCreated } from '../../../Events/utils.events'
import {checkIfTveLoggedIn} from '../../Helpers/helper'
import { handleSeviceTypes } from '../../../../helpers'
import { v4 as uuidv4 } from 'uuid';
import { checkAuthenticationSession, getConfiguration, getTokenAgainstStatement, registerCurrentDevice, retrieveProfileAgainstMvpdCode } from '../../../../components/AdobeRestV2/Apis'
import logger from '../../../../logger'
import { setStorageItem } from '../../../../helpers/storageManager'


function TveLoginV2(props) {

  let tveApiBaseUrl = window.app_data.appcmsPlatform.tveSettings.urlScheme
  let softwareStatement = window.app_data.appcmsPlatform.tveSettings.softwareStatement
  let requestorID = window.app_data.appcmsPlatform.tveSettings.requestorID
  let metadataMap = props?.module?.metadataMap
  let ctaBackgroundColor = props?.module?.layout?.settings?.activeCTAColor
  let mvpdBgColor = props?.module?.layout?.settings?.mvpdBgColor
  let resources = window?.app_data?.appcmsPlatform.tveSettings.resourceIds

  const [mvpd, setMvpd] = useState([])
  const [isLoading,setIsLoading] = useState(false)
  const [resourceIds,setResourceIds] = useState([])
  const [haveResourceId,setHaveResourceId] = useState(false)
  const [haveUserMeta,setHaveUserMeta] = useState(false) 
  const [regCode, setRegCode] = useState('')
  const userMetaObject = useRef({})
  const path = window.location.pathname.includes('checkout') ? '/' : window.location.pathname    
  const isUserMetaDataEnabled = window?.app_data?.appcmsPlatform?.tveSettings?.userMetadataEnabled
  const adobeVersion = window?.app_data?.appcmsPlatform?.tveSettings?.version || "v1"

  const checkAuth = async() => {
    // setIsLoading(true)
    let params = new URLSearchParams(window.location.search);
    let userStatus = params.get("user")
    let user = localStorage.getItem('entitlementToken')
    let userMeta = JSON.parse(user)
    let canAuthenticate = userMeta?.canAuthenticate || null
    if (userStatus === 'registered' || canAuthenticate) {
      setIsLoading(true)
      window?.AE?.getAuthentication()
      let userLoginObject = fetchUserObject()
      if(userLoginObject?.tveMetadata?.userId && canAuthenticate){
        setIsLoading(false)
      }
    } else {
      if (window?.AE) {
        window?.AE?.getAuthentication(`${window?.location?.origin}${window.location.pathname}?user=registered`);
      } else {
        async function checkUserObject() {
          let user = fetchUserObject()
          if (user?.userId && handleSeviceTypes().TVE) {
            loadTve()
            .then((res) => {
              setIsLoading(false)
              if(res) checkAuth()
            })
          } else {
            return
          }
        }
        setIsLoading(false)
        checkUserObject()
      }
    }
  }

  const checkTveAuthv2 = () => {
    const checkServerTveFlag =  Cookies.get('tveFlagInQueryAuth')
    let params = new URLSearchParams(window.location.search);
    let userStatus = params.get("isTveUser")
    const selectedMvpdId = localStorage.getItem('selectedMvpdId') 
    if((userStatus == "Authenticated" && selectedMvpdId) || checkServerTveFlag){
      setIsLoading(true)
      const data = new URLSearchParams();
      data.append('mvpd', selectedMvpdId);
      checkAuthenticationSession(data).then((res) => {
        const isAuthenticated = res.data.reasonType
        const resourceIds = window?.app_data?.appcmsPlatform?.tveSettings?.resourceIds 
        if(isAuthenticated == "authenticated" && selectedMvpdId == res.data.mvpd)
          retrieveProfileAgainstMvpdCode().then((res) => {
            setStorageItem('tveProfileResponse', res.data.profiles[selectedMvpdId].attributes)
            if(resourceIds && resourceIds.length > 0){
              decisionsPreAuthorize(selectedMvpdId).then((preAuthorizeData) => {
                const authorisedResourceIds = []
                const authorisedData = preAuthorizeData.data.decisions
                authorisedData.map((item) => {
                  if(item && item.authorized){
                    authorisedResourceIds.push(item.resource)
                  }
                })
                registerTveUser({
                  tveUserId: res.data.profiles[selectedMvpdId].attributes?.userID?.value || '',
                  mvpd: selectedMvpdId,
                  encryptedZip: res.data.profiles[selectedMvpdId].attributes?.zip?.value || '',
                  path: path,
                  resourceIds: authorisedResourceIds
                })
              })
            }else{
              registerTveUser({ 
              tveUserId: res?.data?.profiles[selectedMvpdId]?.attributes?.userID?.value || '',
              mvpd: selectedMvpdId,
              encryptedZip: res?.data?.profiles[selectedMvpdId]?.attributes?.zip?.value || '',
              path: path, 
              setIsLoading
            })}
            Cookies.remove('tveFlagInQueryAuth')
          })
          .catch((error) => {
            setIsLoading(false)
            if (error.response) {
              logger('Error Code GET Profile:'+ error.response.status,'info', true);
              logger('Error Message GET Profile:'+ error.response.statusText,'info', true);
              logger('Error Data GET Profile:'+ error.response.data, 'info', true);
            } else if (error.request) {
              logger('No response received GET Profile:'+ error.request,'info', true);
            } else {
              logger('Axios Error GET Profile:'+ error.message,'info', true);
            }
            Cookies.remove('tveFlagInQueryAuth')
          })
      }).catch((error) => {
        setIsLoading(false)
        if (error.response) {
          logger('Error Code GET Authentication error:'+ error.response.status,'info', true);
          logger('Error Message GET Authentication error:'+ error.response.statusText,'info', true);
          logger('Error Data GET Authentication error:'+ error.response.data, 'info', true);
        } else if (error.request) {
          logger('No response received GET Authentication error:'+ error.request,'info', true);
        } else {
          logger('Axios Error GET Authentication error:'+ error.message,'info', true);
        }
        Cookies.remove('tveFlagInQueryAuth')
      })
    }
  }

  useEffect(() => {
    let AccessEnablerUrl = window?.app_data.appcmsPlatform.tveSettings.accessEnabler
    if(AccessEnablerUrl && handleSeviceTypes().TVE && adobeVersion == "v1"){
      loadTve()
      .then((res) => {
        if(res) window.accessEnablerDidLoad()
        else console.log("error loading sdk")
      })
    }
    adobeVersion == "v2" && checkTveAuthv2()
    pubsub.subscribe('registerTVE', callNaviagte)
  },[])

  const initiate = (e,code) => {
    e && e.preventDefault();
    const deviceId = btoa(uuidv4());
    const getTveAccessToken = Cookies.get("Tve_Access_token")
    const adobeVersion = window?.app_data?.appcmsPlatform?.tveSettings?.version || "v1"
    if(e){
      code = e.target[0].value
    }
    if(adobeVersion == "v1"){
      axios({
        method: 'GET',
        url: `${tveApiBaseUrl}/api/v1/config/${requestorID}`,
        params: {
        }
    })
    .then((res) =>{
        setMvpd(res?.data?.requestor?.mvpds?.mvpd)
    }).catch(() => {
      alert("Error Occurred")
    })
    }else{
      axios({
          method: 'GET',
          url: `${tveApiBaseUrl}/api/v2/${requestorID}/configuration`,
          headers: { 
            'Authorization': `Bearer ${getTveAccessToken}`,
            'AP-Device-Identifier':`fingerprint ${deviceId}`
          }
      })
      .then((res) =>{
        setMvpd(res?.data?.requestor?.mvpds)
      })
      .catch((error) => {
        if (error.response) {
          logger('Error Code GET Config Flow:'+ error.response.status,'info');
          logger('Error Message GET Config Flow:'+ error.response?.data?.message,'info');
          logger('Error Data GET Config Flow:'+ JSON.stringify(error.response.data), 'info');
        } else if (error.request) {
          logger('No response received GET Config Flow:'+ error.request,'info');
        } else {
          logger('Axios Error GET Config Flow:'+ error.message,'info');
        }
      })
    }
  }

  // TVE magicLink useEffect
  useEffect(() => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    const userTveCode = urlParams.get("tveCode");
    if(userTveCode){
      registerDevice().then((res) => {
        getTokenForDevice({...res.data}).then(() =>{
          initiate(null,userTveCode)
          setRegCode(userTveCode)
        })
        pubsub.publish('apploading', false);
    })
    .catch((err) => {
        console.log(err)
        pubsub.publish('apploading', false);
    })}
}, [])



  const callNaviagte = (data) => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    const authToken = urlParams.get("auth");
    const userEmail = urlParams.get("email");
    const userTveCode = urlParams.get("tveCode");
    if(authToken && userEmail && userTveCode){
      return
    }
      else{ window.location.href = data} 
  }


if(adobeVersion == "v1"){
  window.accessEnablerDidLoad = () => {
    let ss = softwareStatement
    console.log("inside v2 didload")
    if(window?.AccessEnabler){
      window.AE = new window.AccessEnabler.AccessEnabler(ss)
      window.entitlementLoaded();
    }
  }

  window.entitlementLoaded = () => {
    if(requestorID){
      try{
        window.AE?.setRequestor(requestorID);
        window.setConfig()
      }catch(err){
        console.log("Error Occurred",err);
        setTimeout(() => {
          window.entitlementLoaded()
        },1000)
      }
    }else{
      setIsLoading(false)
    }
  }

  window.setConfig = async(configuration) => {
    setIsLoading(false)
    checkAuth()
    // window.AE.getAuthentication(`${window?.location?.origin}${window.location.pathname}?user=registered`);
  }

  window.setMetadataStatus = (key, encrypted, data) => {
    userMetaObject.current[key] = data

    if(key==="householdID" || key==="hba_status"){
      Cookies.set(key,data)
    }
    if(userMetaObject.current.hasOwnProperty('userID') 
    && userMetaObject.current.hasOwnProperty('zip') 
    &&  userMetaObject.current.hasOwnProperty('encryptedZip')){
      publishUserCreated({status : true })
      setHaveUserMeta(true)
      // registerTveUser({tveUserId:userMetaObject.current.userID,mvpd:mvpd,zip:zipCode,encryptedZip:userMetaObject.current.encryptedZip,path:path,})
    }
  }

  window.displayProviderDialog = (mvpdList) => {
  setIsLoading(false)
  setMvpd(mvpdList)
  return new Promise((resolve,reject) => {
    if(mvpdList?.length > 0) return resolve(mvpdList)
    else return reject()
  })
}

  window.setAuthenticationStatus = (isAuthenticated, errorCode) => {
    if(isAuthenticated == 1){
      if(isUserMetaDataEnabled){
        window?.AE?.getMetadata('zip')
        window?.AE?.getMetadata('userID')
        window?.AE?.getMetadata('encryptedZip')
        window?.AE?.getMetadata('hba_status')
        window?.AE?.getMetadata('householdID')
      }
      if(resources?.length > 0){
        window?.AE?.checkPreauthorizedResources(resources)
      } 
    }else if(isAuthenticated == 0 ){
      setIsLoading(false)
    }
  }

  window.preauthorizedResources = (resource) => {
  setResourceIds(resource)
  localStorage.setItem('resourceIds',JSON.stringify(resource))
  setHaveResourceId(true);
  }
}

  const getZipCode = () => {
    let zipCode = userMetaObject?.current?.zip || null
    if(zipCode && typeof(zipCode) === "object" && zipCode.length > 0) {
      zipCode = JSON.stringify(zipCode)
    }

    return zipCode;
  }

  const signWithTve = async () => {
    let entitlementToken = localStorage.getItem('entitlementToken')
    let user = JSON.parse(entitlementToken)
    let mvpd = user?.mvpd || null
    let resources = haveResourceId && localStorage.getItem('resourceIds') && JSON.parse(localStorage.getItem('resourceIds'))
    let userLoginObject = fetchUserObject()

    if(user?.canAuthenticate && userLoginObject?.tveMetadata?.userId){
      return ;
    }

    if(resources?.length > 0 && isUserMetaDataEnabled && haveUserMeta){
      registerTveUser({ 
        tveUserId: userMetaObject.current.userID,
        mvpd: mvpd,
        zip: getZipCode(),
        encryptedZip: userMetaObject.current.encryptedZip,
        path: path, 
        resourceIds: resources ? resources : [],
        setIsLoading
      })
    }else if((resources?.length == 0 || resources == false) && isUserMetaDataEnabled && haveUserMeta){
      registerTveUser({ 
        tveUserId: userMetaObject.current.userID,
        mvpd: mvpd,
        zip: getZipCode(),
        encryptedZip: userMetaObject.current.encryptedZip,
        path: path, 
        setIsLoading
      })
    }else if(resources){
      registerTveUser({ 
        mvpd: mvpd,
        path: path, 
        resourceIds: resources ? resources : [],
        setIsLoading
      })
    }else{
      console.log('No user meta data or resource id')
    }
  }
  useEffect(() => {
    adobeVersion == "v1" && signWithTve()
  },[haveResourceId,haveUserMeta,resourceIds])


useEffect(() => {
  const getTveAccessToken = Cookies.get('TveAccessToken')
  const getFingerprintDeviceId = localStorage.getItem('fingerprintDeviceId')
  adobeVersion == "v2" && ((!getTveAccessToken || !getFingerprintDeviceId) ? initiateTveV2() : getConfiguration().then((res) => {setMvpd(res)}))
}, [])

const initiateTveV2 = () => {
    registerCurrentDevice().then((res) => {
      getTokenAgainstStatement({...res.data}).then(() => {
        getConfiguration().then((res) => {
          setMvpd(res)
        })
      })
    })
}
  return (
      <div className='Tve-V2-container'>
        <div className='connectTveLogin site-color'>
          {isLoading && <div className='tve-loader'>
          <Spinner />
          </div>}
          <TveDialogBox providers={mvpd} regCode={regCode} chooseProviderTxt={metadataMap?.chooseProviderTxt} chooseProviderDescription={metadataMap?.chooseProviderDescription} skipBtnText={metadataMap?.skipBtn} ctaBackgroundColor={ctaBackgroundColor} mvpdBgColor={mvpdBgColor}/>
        </div>
      </div>
  )
}

export default TveLoginV2;
